import React from 'react'
import { Avatar, Box, Card, CardContent, Typography } from '@mui/material'
import ApartmentIcon from "@mui/icons-material/Apartment";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import TimelineIcon from "@mui/icons-material/Timeline";

const StatewiseStats = ({ selectedState }) => {
    return (
        <Card sx={{ borderRadius: "20px", boxShadow: 1 }}>
            <CardContent>
                <Typography
                    variant="h6"
                    fontWeight={600}
                    mb={2}
                    sx={{ minHeight: 64 }}
                >
                    {selectedState?.state_name} - State-wise Statistics
                </Typography>

                <Box display="flex" flexDirection="column" gap={2}>
                    {/* TCCC */}
                    <Card variant="outlined" sx={{ borderRadius: 3, p: 2 }}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="body2" color="gray">
                                Total TCCC
                            </Typography>
                            <Avatar
                                sx={{ bgcolor: "#E0E7FF", width: 34, height: 34 }}
                            >
                                <ApartmentIcon
                                    sx={{ color: "#6C7FF9", fontSize: 20 }}
                                />
                            </Avatar>
                        </Box>
                        <Typography variant="h6" fontWeight={700} mt={1}>
                            {selectedState?.total_mi || "0"}
                        </Typography>
                    </Card>

                    {/* DCCC */}
                    <Card variant="outlined" sx={{ borderRadius: 3, p: 2 }}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="body2" color="gray">
                                Total DCCC
                            </Typography>
                            <Avatar
                                sx={{ bgcolor: "#E0E7FF", width: 34, height: 34 }}
                            >
                                <BusinessIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />
                            </Avatar>
                        </Box>
                        <Typography variant="h6" fontWeight={700} mt={1}>
                            {selectedState?.total_dccc || "0"}
                        </Typography>
                    </Card>

                    {/* Beneficiaries */}
                    <Card variant="outlined" sx={{ borderRadius: 3, p: 2 }}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="body2" color="gray">
                               Total Registered Beneficiaries
                            </Typography>
                            <Avatar
                                sx={{ bgcolor: "#E0E7FF", width: 34, height: 34 }}
                            >
                                <GroupsIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />
                            </Avatar>
                        </Box>
                        <Typography variant="h6" fontWeight={700} mt={1}>
                            {selectedState?.total_patients || "0"}
                        </Typography>
                    </Card>

                    {/* Chemo */}
                    <Card variant="outlined" sx={{ borderRadius: 3, p: 2 }}>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="body2" color="gray">
                                Total Completed Chemo Sessions
                            </Typography>
                            <Avatar
                                sx={{ bgcolor: "#E0E7FF", width: 34, height: 34 }}
                            >
                                <TimelineIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />
                            </Avatar>
                        </Box>
                        <Typography variant="h6" fontWeight={700} mt={1}>
                            {selectedState?.total_chemo || "0"}
                        </Typography>
                    </Card>
                </Box>
            </CardContent>
        </Card>
    )
}

export default StatewiseStats